import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createAirport } from "../../api/apiAirports";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateAirport = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createAirportAction, isPending } = useMutation({
        mutationFn: createAirport,
        onSuccess: (res) => {
            const message = res?.message || "Airport created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
            navigate("/airports");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create airport");
        },
    });

    return { createAirport: createAirportAction, isPending };
};

export default useCreateAirport;
